<template>
  <div :data-tooltip="text || null" :class="{ 'Tooltip--light': variant === 'light', 'Tooltip--bottom': placement === 'bottom' }">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    },
    // 'dark' (default) — black bubble, white text
    // 'light' — white bubble with shadow (no border: a CSS-triangle arrow
    //   can't carry a border, so a bordered bubble would show a seam)
    variant: {
      type: String,
      required: false,
      default: 'dark'
    },
    // 'top' (default) — bubble above the trigger
    // 'bottom' — bubble below it, for triggers near the top of the page where
    //   an upward bubble is clipped
    placement: {
      type: String,
      required: false,
      default: 'top'
    }
  }
}
</script>

<style lang="postcss" scoped>
/**
  * Tooltip Styles
  */

/* Add this attribute to the element that needs a tooltip */
[data-tooltip] {
  position: relative;
  z-index: 2;
  cursor: pointer;
}

/* Hide the tooltip content by default */
[data-tooltip]:before,
[data-tooltip]:after {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}

/* Position tooltip above the element */
[data-tooltip]:before {
  position: absolute;
  bottom: 115%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 5px;
  /* Sized to its text, not a fixed block; long text still wraps at 240px. */
  width: max-content;
  max-width: 240px;
  padding: 5px 8px;
  border-radius: 6px;
  background-color: #000;
  color: #fff;
  content: attr(data-tooltip);
  text-align: center;
  font-size: 12px;
  line-height: 1.35;
}

/* Triangle hack to make tooltip look like a speech bubble */
[data-tooltip]:after {
  position: absolute;
  bottom: 115%;
  left: 50%;
  margin-left: -5px;
  width: 0;
  border-top: 5px solid #000;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  content: ' ';
  font-size: 0;
  line-height: 0;
}

/* Show tooltip content on hover */
[data-tooltip]:hover:before,
[data-tooltip]:hover:after {
  visibility: visible;
  opacity: 1;
}

/* Bottom placement: the same bubble, mirrored under the trigger. */
.Tooltip--bottom[data-tooltip]:before {
  top: 115%;
  bottom: auto;
  margin-top: 5px;
  margin-bottom: 0;
}
.Tooltip--bottom[data-tooltip]:after {
  top: 115%;
  bottom: auto;
  border-top: 0;
  border-bottom: 5px solid #000;
}

/* Light variant */
.Tooltip--light[data-tooltip]:before {
  background-color: #fff;
  color: #334155;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.3;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.2);
}
.Tooltip--light[data-tooltip]:after {
  border-top-color: #fff;
  filter: drop-shadow(0 2px 1px rgba(15, 23, 42, 0.08));
}
.Tooltip--light.Tooltip--bottom[data-tooltip]:after {
  border-bottom-color: #fff;
  filter: drop-shadow(0 -2px 1px rgba(15, 23, 42, 0.08));
}
</style>
